// src/components/SentryErrorBoundary.tsx
import * as Sentry from "@sentry/react";
import React from "react";
import { Typography, Button, Box } from "@mui/material";

interface Props {
  children: React.ReactNode;
}

function ErrorFallback() {
  const handleGoHome = () => {
    // Use window.location for reliable navigation in error scenarios
    // This ensures navigation works even if React Router context is broken
    window.location.href = "/pricing-audit-tool/instances";
  };

  return (
    <Box textAlign="center" p={4}>
      <Typography variant="h4" gutterBottom>
        Something went wrong
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={3}>
        An unexpected error occurred. Please return to the home page.
      </Typography>
      <Button variant="contained" onClick={handleGoHome} type="button">
        Go to Home
      </Button>
    </Box>
  );
}

function SentryErrorBoundary({ children }: Props) {
  return (
    <Sentry.ErrorBoundary fallback={() => <ErrorFallback />} showDialog>
      {children}
    </Sentry.ErrorBoundary>
  );
}

export default SentryErrorBoundary;
